import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

export const ResendInvoiceNoticeMutation = graphql.persisted(
  "ResendInvoiceNotice",
  graphql(`
    mutation ResendInvoiceNotice($input: ResendInvoiceNoticeInput!) {
      resendInvoiceNotice(input: $input) {
        success
        userErrors { message path }
      }
    }
  `)
);

export function useResendInvoiceNotice() {
  return useMutation(ResendInvoiceNoticeMutation);
}
